import { observer } from "mobx-react"
import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material"
import { t } from "@lingui/macro"

import { IIntegrationConnectorItem } from "src/views/integration-connector/type"

interface IProps {
    connectors: IIntegrationConnectorItem[]
    selectedValue: string
    onSelectionChange: (value: number) => void
    errorMessage?: string
    disabled?: boolean
    width?: string | number
}

export const ConnectorDropdown = observer((props: IProps) => {
    const {
        connectors,
        selectedValue,
        onSelectionChange,
        errorMessage,
        disabled,
        width = "100%",
    } = props

    return (
        <FormControl style={{ breakInside: "avoid", width }}>
            <InputLabel id="type-label">{t`resource-detail-modal.connector-label`}</InputLabel>
            <Select
                data-testid="connector-dropdown"
                labelId="connector-label"
                id="connector"
                value={selectedValue}
                label={t`resource-detail-modal.connector-label`}
                onChange={(event) =>
                    onSelectionChange(Number(event.target.value))
                }
                error={Boolean(errorMessage)}
                disabled={disabled}
            >
                {connectors.map((item) => (
                    <MenuItem
                        value={item.integrationId}
                        key={item.integrationId}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
            {Boolean(errorMessage) && (
                <FormHelperText error={true}>{errorMessage}</FormHelperText>
            )}
        </FormControl>
    )
})
